
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyLateralCanGreen as ObiSimplifiedBuoyLateralCanGreenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-lateral-can-green.js';
 
 
 

 
 export const ObiSimplifiedBuoyLateralCanGreen = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-lateral-can-green',
   elementClass: ObiSimplifiedBuoyLateralCanGreenElement,
   events: {
     
   }
  });
 
 